import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { Container, Button, Col, Row, Card } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import { DashboardOutlined } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import Can, { AbilityContext } from 'components/Can';
import ProfileType from 'enums/ProfileTypes';

import Creative from 'components/Dashboard/Creative/List';
import Analyst from 'components/Dashboard/Analista';
import Director from 'components/Dashboard/Diretor';

const Dashboard = () => {
  // const ability = useContext(AbilityContext);
  // const [creativeOnly, setCreativeOnly] = useState(false);
  // const [analystOnly, setAnalystOnly] = useState(false);
  // const [managerOnly, setManagerOnly] = useState(false);
  // const [directorOnly, setDirectorOnly] = useState(false);
  
  // useEffect(() => {
  //   ability.can('viewMediaCreation', 'App') && setCreativeOnly(true);
  //   ability.can('viewAnalyst', 'App') && setAnalystOnly(true);
  //   ability.can('viewDirector', 'App') && setDirectorOnly(true);
  // });

  // if (analystOnly && !managerOnly && !creativeOnly && !directorOnly) return <Redirect to="analyst" />
  // if (creativeOnly && !analystOnly && !managerOnly && !directorOnly) return <Redirect to="creative" />
  // if (directorOnly && !analystOnly && !managerOnly && !creativeOnly) return <Redirect to="creative" />

  const user = JSON.parse(localStorage.getItem('user'));
  
  const { t } = useTranslation();
  const history = useHistory();
  const dashboard = window.location.pathname.split('/')[1];

  const canViewCreative = () => [ProfileType.CRIATIVO].includes(user.profiles[0].id);
  const canViewAnalyst = () => [ProfileType.ANALISTA, ProfileType.CONTROLADORIA].includes(user.profiles[0].id);
  const canViewDirector = () => [ProfileType.DIRETOR].includes(user.profiles[0].id);

  function createCard(title, link, info) {
    return (
      <Col sm="12" md="6" lg="4" className="mt-2 p-1">
        <Card.Body
          style={{ height: '12rem', marginBottom: '10px' }}
          className="shadow bg-white rounded"
        >
          <Link to={link} className="text-primary font-weight-bold">
            {title}
          </Link>
          <Card.Text style={{ marginTop: '12px' }}>{info}</Card.Text>
          <Button
            block
            variant="primary-login"
            className="login-btn mr-1"
            size="md"
            onClick={() => {
              history.push(link);
            }}
          >Acessar </Button>
        </Card.Body>
      </Col>
    );
  }
  
  if (canViewCreative() || dashboard == "creative") {
    return (<>
      <Can do="viewMediaCreation" on="App">
        <Creative />
      </Can>
    </>);
  } else if (canViewAnalyst() || dashboard == "analyst") {
    return (<>
      <Can do="viewAnalyst" on="App">
        <Analyst />
      </Can>
    </>);
  } else if (canViewDirector() || dashboard == "director") {
    return (<>
      <Can do="viewDirector" on="App">
        <Director />
      </Can>
    </>);
  } else {
    return (
      <>
        <Container>
          <Row className="col-12 m-0 p-0">
            <Col className="d-flex mt-3 mb-3">
              <DashboardOutlined className="icon-title" />
              <h4 className="title-dashboard mt-2">{t('title:dashboard')}</h4>
            </Col>
          </Row>
          <Row className="mt-3 mb-3 col-12 m-0">
            <Can do="viewAnalyst" on="App">
              {createCard(
                'Geral',
                '/analyst',
                'Dashboard com informações resumidas das verbas, margens, ações e planos gerais.'
              )}
            </Can>
            <Can do="viewMediaCreation" on="App">
              {createCard(
                'Criativo',
                '/creative',
                'Dashboard com informações do criativo para desenvolvimento de materiais gráficos.'
              )}
            </Can>
            <Can do="viewDirector" on="App">
              {createCard(
                'Diretor',
                '/director',
                'Dashboard com informações mensais de gastos, faturamentos e receita.'
              )}
            </Can>
          </Row>
        </Container>
      </>
    );
  }
};

export default MasterPage(Dashboard);